var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.78516 12.4994H48.2137M24.9994 37.4994V48.2137M19.6423 37.4994L8.92801 48.2137M30.3566 37.4994L41.0709 48.2137M44.6423 1.78516H5.35658C4.40938 1.78516 3.50098 2.16143 2.8312 2.8312C2.16143 3.50098 1.78516 4.40938 1.78516 5.35658V33.928C1.78516 34.8752 2.16143 35.7836 2.8312 36.4534C3.50098 37.1232 4.40938 37.4994 5.35658 37.4994H44.6423C45.5895 37.4994 46.4979 37.1232 47.1677 36.4534C47.8375 35.7836 48.2137 34.8752 48.2137 33.928V5.35658C48.2137 4.40938 47.8375 3.50098 47.1677 2.8312C46.4979 2.16143 45.5895 1.78516 44.6423 1.78516Z",
    stroke: "#FAFAFA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.e6da3979e756576418bb1215e2076b23.svg";
export { ForwardRef as ReactComponent };